import { useEffect, useState } from 'react';
import { MoneyInput } from '@/components/ui';

interface PartInputProps {
  /** The amount as the split has it now (whole rupees). */
  value: number;
  /** Called on every keystroke with the typed amount (empty = 0); the split may adjust it (e.g. cap it). */
  onChange: (value: number) => void;
  'aria-label': string;
  max?: number;
  className?: string;
}

/**
 * A ₹ input for a part of the split. Keeps the typed text while focused (so it can be emptied and retyped), and
 * shows the split's figure again once it loses focus or the split changes it from elsewhere.
 */
export function PartInput({ value, onChange, max, className, ...rest }: PartInputProps) {
  const [text, setText] = useState(String(value));
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setText(String(value));
  }, [value, focused]);

  return (
    <MoneyInput
      size="md"
      value={text}
      max={max}
      className={className}
      aria-label={rest['aria-label']}
      onFocus={(e) => {
        setFocused(true);
        e.currentTarget.select();
      }}
      onBlur={() => setFocused(false)}
      onChange={(v) => {
        setText(v);
        onChange(Math.round(Number(v)) || 0);
      }}
    />
  );
}
